import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import VatCompanyList from "./VatCompanyList";
import { VatCompany } from "lib/models";
import { popupZIndex } from "lib/utils";

const VatCompanyPopup = ({
  open,
  onOpenChange,
  currentVatCompanyId,
  onSelectVatCompany,
  popupLevel,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentVatCompanyId: number;
  onSelectVatCompany: (vatCompany: VatCompany) => void;
  popupLevel: number;
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={`w-[calc(100%-1rem)] max-w-[calc(100%-1rem)] md:max-w-screen-2xl max-h-[95%] min-h-[95%] flex flex-col justify-start overflow-x-hidden overflow-y-auto thin-scrollbar`}
        zIndex={popupZIndex(popupLevel)}
      >
        <DialogHeader>
          <DialogTitle>거래처 선택</DialogTitle>
        </DialogHeader>
        <VatCompanyList
          currentVatCompanyId={currentVatCompanyId}
          onSelectVatCompany={onSelectVatCompany}
          popupLevel={popupLevel + 1}
        />
      </DialogContent>
    </Dialog>
  );
};

export default VatCompanyPopup;
